import React, {useEffect, useState} from "react";
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAlertContext } from "../context/Alerts.js";
import SimpleBar from 'simplebar-react';
import axios from 'axios';
import { useBaseUrlContext } from "../context/Base_url.js";
import { useQuery, useQueryClient, useInfiniteQuery } from "@tanstack/react-query";
import { useErrHandleContext } from "../context/Err_handle.js";

import {ThemeProvider, Container, Typography, Tabs, Tab, Menu, MenuItem, Table, TableBody, TableCell, TableHead, TableRow, IconButton, Tooltip, Checkbox} from '@mui/material';
import {ThemeCustom} from '../styles/Theme.js';
import 'simplebar-react/dist/simplebar.min.css';
import 'filepond/dist/filepond.min.css';

import ButtonImgMain from "../components/button/Button_img_main.js";
import FooterBarReveiw from "../components/navbar/Footer_bar_review.js";
import ModalApplicantSummary from "../components/Modal/Modal_applicant_summary.js";
import ModalPdfView from "../components/Modal/Modal_pdf_view.js";

import NotFound from '../assets/no-results-found.svg'
import TrashDark from '../assets/trash-dark.svg';
import CloseCircle from '../assets/close-circle-red.svg';
import Description from '../assets/message-text.svg';
import View from '../assets/eye.svg';
import Uncheck from '../assets/square.svg';
import Check from '../assets/tick-square.svg';
import ModalDelete from "../components/Modal/Modal_delete.js";
import Import from '../assets/import.svg'
import ClipboardIcon from '../assets/Clipboard.svg';
import linkedTo from '../assets/UserAdd.svg';
import LoaderIcon from '../assets/loader.gif'

const UnAssignedCv = () => {

    const [value, setValue] = useState(0);
    const [files, setFiles] = useState([]);
    const [isActive, setIsActive] = useState(true) 
    const [openSummary, setOpenSummary] = useState(false) 
    const [openPdfView, setOpenPdfView] = useState(false) 
    const [selectCheckbox, setSelectCheckbox] = useState([])
    const [openDelete, setOpenDelete] = useState(false) 
    const [delType, setDelType] = useState(1)
    const [deleteId, setDeleteId] = useState('')
    const [jobId, setJobId] = useState('')
    const [summaryDiscription, setSummaryDiscription] = useState('')
    const [summaryBreakdown, setSummaryBreakdown] = useState([])
    const [aplicantName, setAplicantName] = useState('')
    const [rating, setRating] = useState('')
    const [cVLink, setCVLink] = useState('')
    const [cvProcess, setCvProcess] = useState(false)
    const [selectAll, setSelectAll] = useState(false)
    const [loader, setLoader] = useState(true)
    const { baseUrl } = useBaseUrlContext();
    const { sucessAlert, failAlert } = useAlertContext();
    const queryClient = useQueryClient()
    const location = useLocation();
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState(null);
    const [activeMenuIndex, setActiveMenuIndex] = useState(null);
    //const [jobOpenings, setJobOpenings] = useState(['Products', 'Pricing', 'Blog'])
    const [hasError, setHasError] = useState(false);
    const {handleError} = useErrHandleContext()

    //useEffect(()=>{console.log('file',files)},[files])
    useEffect(()=>{console.log('selectCheckbox',selectCheckbox)},[selectCheckbox])

    //get job id - remove later

    useEffect(()=>{
        const jobId = location.pathname.split('/').at(-1);
        console.log('jobId', jobId)
        setJobId(jobId)
    },[])

    //get joblist

    const fetchJobData = async ({pageParam = 0}) => {

        //remove pre-open job values from session storage

        sessionStorage.removeItem("jobRef")
        sessionStorage.removeItem("jobName")
        sessionStorage.removeItem("jobStatus")
        
        try{

            const header = {
                'Authorization': localStorage.getItem('token')
            }

            const response = await axios.get(`${baseUrl}/job-descriptions/activeJobDetails?page=0&size=50`, {headers:header})
            
                const res = response.data;
                if(res.code === 200){
                    console.log('JobList', res.data)
                    return res.data;
                }
                else{
                    console.log(res, '204 error')
                    if(res.code !== 204){
                        failAlert(true, res.message)
                        
                    }

                    setLoader(false)
                    
                    throw new Error()
                }   

        } catch(error) {

            console.log('error', error)
            handleError(error)
            setLoader(false)
            return [];
        }

    }

    //get cv list

    const fetchCvData = async ({queryKey, pageParam = 0}) => {

        const [_key, value ] = queryKey
        console.log('queryKey > ', queryKey, pageParam)

            try{

                const header = {
                    'Authorization': localStorage.getItem('token')
                }
               
                const response = await axios.get(`${baseUrl}/email/gptClassifiedDocs?status=${value === 1 ? 'REJECTED' : 'PENDING'}&page=${pageParam}&size=10`, {headers:header})
                
                const res = response.data
                console.log('res', response);
    
                if(res.code === 200){
                    console.log('cvList', res.data)
                    //setLoader(false)
                    return {
                        ...res.data,
                        nextCursor: res.data.lastPage ? null : pageParam + 1, 
                    };
                }
                else{
                    console.log(res, '204 error')
                    if(res.code !== 204){
                        failAlert(true, res.message)
                        
                    }

                    setLoader(false)
                    
                    throw new Error()
                    
                }

            } catch(error) {

                console.log('error', error)
                handleError(error)
                setLoader(false)
                return [];
            }

        
    }

    //useQuery hook for get cv detail

    const {isLoading:isLoadingCvList, data:cvList, fetchNextPage:cvListNextPage, isFetchingNextPage:isFetchingCvListNextPage, hasNextPage:hasNextCvListPage} = useInfiniteQuery({

        queryKey: ['fetchCvData', value],
        queryFn: fetchCvData,
        cacheTime: 30 * 60 * 1000,
        refetchInterval: 5000,
        initialPageParam: 0,
        getNextPageParam: (lastPage) => lastPage?.nextCursor || null,

    })

     //useQuery hook for get active job detail

     const {isLoading, data:jobOpenings, fetchNextPage:fetchNextJobPage, isFetchingNextPage:isFetchingNextJobPage, hasNextPage:hasNextJobPage} = useInfiniteQuery({

        queryKey: ['fetchJobData'],
        queryFn: fetchJobData,
        cacheTime: 30 * 60 * 1000,
        initialPageParam: 0,
        getNextPageParam: (lastPage) => lastPage?.nextCursor || null,

    })

    //query handle menually for get cv detail

    const fetchCvDataHandler = async () => {
        queryClient.invalidateQueries(['fetchCvData', value])
    }


    //submit reject single

    const rejectSingle = (id) => {

        console.log('reject')

        const header = {
            'Authorization': localStorage.getItem('token'),
            'Content-Type': 'application/json'
        }

        const data = JSON.stringify({
            'idList': [id]
        })

        axios
        .put(`${baseUrl}/email/updateStatus/REJECTED`, data, {headers:header})
        .then((response) => {
            console.log('res', response);
            const res = response.data;
            if(res.code === 200){
                console.log('reject res', res.data)
                sucessAlert(true, res.message)
                fetchCvDataHandler()
                setSelectAll(false)
                setSelectCheckbox([])
            }
            else{
                console.error(res.message)
                failAlert(true, res.message)
            }
        })
        .catch((err) => {
            console.error('Internal Server Error', err)
            failAlert(true,'Oops! Something went wrong. Please hang tight and try again in a moment.')
        })

    }

    //submit reject 

    const reject = () => {

        console.log('reject')

        const header = {
            'Authorization': localStorage.getItem('token'),
            'Content-Type': 'application/json'
        }

        const data = JSON.stringify({
            'idList': selectCheckbox
        })

        axios
        .put(`${baseUrl}/email/updateStatus/REJECTED`, data, {headers:header})
        .then((response) => {
            console.log('res', response);
            const res = response.data;
            if(res.code === 200){
                console.log('reject res', res.data)
                sucessAlert(true, res.message)
                fetchCvDataHandler()
                setSelectAll(false)
                setSelectCheckbox([])
            }
            else{
                console.error(res.message)
                failAlert(true, res.message)
            }
        })
        .catch((err) => {
            console.error('Internal Server Error', err)
            failAlert(true,'Oops! Something went wrong. Please hang tight and try again in a moment.')
        })

    }

    //remove all requirements

    const delAll = () => {
        setOpenDelete(true)
        setDelType(2)
    }

    //tab change

    const handleChange = (e, val) => {
        console.log('handleChange', val);
        setValue(val)
    }

    //delete func Multiple

    const delFuncMultiple = () => {

        console.log('this is delete', localStorage.getItem('token'))

        const header = {
            'Authorization': localStorage.getItem('token'),
            'Content-Type': 'application/json'
        }

        const data = JSON.stringify({
            'idList': selectCheckbox
        })

        axios
        .post(`${baseUrl}/email/delete`, data,  {headers:header})
        .then((response) => {
            console.log('res', response);
            const res = response.data;
            if(res.code === 200){
                console.log('delete res', res.data)
                sucessAlert(true, res.message)
                setFiles([])        
                fetchCvDataHandler()
                setSelectAll(false)
                setSelectCheckbox([])
            }
            else{
                console.error(res.message)
                failAlert(true, res.message)
            }
            setOpenDelete(false)
        })
        .catch((err) => {
            console.error('Internal Server Error', err)
            failAlert(true,'Oops! Something went wrong. Please hang tight and try again in a moment.')
            setOpenDelete(false)
        })

    }

    //delete func single

    const delFuncSingle = () => {

        console.log('this is delete', localStorage.getItem('token'))

        const header = {
            'Authorization': localStorage.getItem('token'),
            'Content-Type': 'application/json'
        }

        const data = JSON.stringify({
            'idList': [deleteId]
        })

        axios
        .post(`${baseUrl}/email/delete`, data,  {headers:header})
        .then((response) => {
            console.log('res', response);
            const res = response.data;
            if(res.code === 200){
                console.log('delete res', res.data)
                sucessAlert(true, res.message)
                setFiles([])        
                fetchCvDataHandler()
                setSelectAll(false)
                setSelectCheckbox([])
            }
            else{
                console.error(res.message)
                failAlert(true, res.message)
            }
            setOpenDelete(false)
            setDeleteId('')
        })
        .catch((err) => {
            console.error('Internal Server Error', err)
            failAlert(true,'Oops! Something went wrong. Please hang tight and try again in a moment.')
            setOpenDelete(false)
            setDeleteId('')
        })

    }

    //Multiple download

    const download = () => {

        const header = {
            'Authorization': localStorage.getItem('token'),
            'Content-Type': 'application/json',
        }

        const data = JSON.stringify({
            'idList': selectCheckbox
        })

        axios
        .post(`${baseUrl}/email/download`, data, {headers:header, responseType:'arraybuffer'})
        .then((response) => {
            console.log('download multiple res', response.data)
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${selectCheckbox.length}-files.zip`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
        .catch((err) => {
            console.error('Internal Server Error', err)
            failAlert(true,'Oops! Something went wrong. Please hang tight and try again in a moment.')
        })

    }

    //Download single

    const downloadSingle = (id, fileName) => {
        
        const header = {
            'Authorization': localStorage.getItem('token'),
            'Content-Type': 'application/json',
        }

        const data = JSON.stringify({
            'idList': [id]
        })

        axios
        .post(`${baseUrl}/email/download`, data, {headers:header, responseType:'blob'})
        .then((response) => {

            console.log('download res', response.data)
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
    
        })
        .catch((err) => {
            console.error('Internal Server Error', err)
            failAlert(true,'Oops! Something went wrong. Please hang tight and try again in a moment.')
        })

    }

    //summary popup open

    const summary = (discription, name, rating, sBreakdown)=>{
        setOpenSummary(true); 
        setSummaryDiscription(discription)
        setAplicantName(name)
        setRating(rating)
        setSummaryBreakdown(sBreakdown)
    }

    //Cv pdf viewer

    const viewResume = (pdf) => {
        setOpenPdfView(true)
        setCVLink(pdf)
        console.log('cv link', pdf)
    }

    //Checkbox select

    const isChecked = (checked, id, status) => {

        if(checked){
            setSelectCheckbox([...selectCheckbox, id])
        }
        else{
            const cvUnChecked = selectCheckbox.filter(select => select !== id)
            setSelectCheckbox(cvUnChecked)
        }

    }

    //select all

    const isCheckedAll = (checked) => {
        console.log('isCheckedAll', checked)

        if(checked){
            setSelectAll(true)
            const allSelect = cvList?.pages?.flatMap((cvContent, index) => {
                return cvContent.content.map((cv, i) => {
                    console.log('cv***************2', cv)
                    if(cv.status === 'PENDING' || cv.status === 'FAILED' || cv.status === 'REJECTED'){
                        console.log('cv***************3', cv)
                        return cv.id;
                    }
                    console.log('cv***************4', cv)
                    return undefined;
                })
            }).filter(id => id !== undefined)

            console.log('cv***************allSelect', allSelect)
            setSelectCheckbox(allSelect)

        }
        else{
            console.log('cv***************else')
            setSelectAll(false)
            setSelectCheckbox([])
        }

    }

    //select all change when selecting the indvidual checkboxes

    useEffect(()=>{

         if(selectCheckbox.length > 0){
            const allSelect = cvList?.pages?.flatMap((cvContent, index) => {
                return cvContent.content.map((cv, i) => {
                    //console.log('cv***************2', cv)
                    if(cv.status === 'PENDING' || cv.status === 'FAILED' || cv.status === 'REJECTED'){
                        return cv.id;
                    }
                    return undefined;
                })
            }).filter(id => id !== undefined)
            console.log('allSelect.length', allSelect.length, selectCheckbox.length)
            allSelect.length === selectCheckbox.length ? setSelectAll(true) : setSelectAll(false)
        }
        else{
            setSelectAll(false)
        }

    },[selectCheckbox])

    //remove selected value when tab change

    useEffect(()=>{

        setSelectAll(false)
        setSelectCheckbox([])
        fetchCvDataHandler()

    },[value])

    //convert timestamp

    const covertTimestamp = (timestamp) => {

        if (!timestamp) return 'N/A';
        
        const date = new Date(JSON.parse(timestamp));

        const formattedDate = date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
      
        return formattedDate;

    }  

    const handleMenu = (event, index) => {
        setAnchorEl(event.currentTarget);
        setActiveMenuIndex(index);
    };
    
    const handleClose = () => {
        setAnchorEl(null);
        setActiveMenuIndex(null);
    };

    //Assign to job

    const assignToJob = (jobId, docId) => {

        console.log('assignToJob', jobId, docId)

        const header = {
            'Authorization': localStorage.getItem('token'),
            'Content-Type': 'application/json'
        }

        const data = JSON.stringify({
            'docId': docId,
            'jobId': jobId
        })

        axios
        .post(`${baseUrl}/email/assignJobForDoc`, data, {headers:header})
        .then((response) => {
            console.log('res', response);
            const res = response.data;
            if(res.code === 200){
                console.log('shortlist res', res.data)
                sucessAlert(true, res.message)
            }
            else{
                console.error(res.message)
                failAlert(true, res.message)
            }
        })
        .catch((err) => {
            console.error('Internal Server Error', err)
            failAlert(true,'Oops! Something went wrong. Please hang tight and try again in a moment.')
        })

    }

    //job status

    const hasJobActive = (closeDate) => {

        const currentDate = new Date();
        const closingDate = new Date(closeDate);

        // Check if the target date has passed today
        const hasPassed = closingDate > currentDate;
        return hasPassed;
        
    }


    //remove later

    useEffect(()=>{
        console.log('selectCheckbox > ', selectCheckbox, 'anchorElUser', anchorEl)
    },[selectCheckbox, anchorEl])

    // Handle infinite scrolling

    const handleScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        if (scrollHeight - scrollTop <= (clientHeight + 5) && hasNextCvListPage && !isFetchingCvListNextPage) {
            cvListNextPage();
        }
    };

useEffect(()=>{
    console.log('jobOpenings', jobOpenings)
},[jobOpenings])

    return(
        <ThemeProvider theme={ThemeCustom}>
            <ModalApplicantSummary
                setOpenSummary={setOpenSummary}
                openSummary={openSummary}
                summaryDiscription={summaryDiscription}
                aplicantName={aplicantName}
                rating={rating}
                summaryBreakdown={summaryBreakdown}
            />
            <ModalPdfView
                setOpenPdfView={setOpenPdfView}
                openPdfView={openPdfView}
                cVLink={cVLink}
            />
            <ModalDelete
                setOpenDelete={setOpenDelete}
                openDelete={openDelete}
                delFuncMultiple={delFuncMultiple}
                delType={delType}
                selectedCount={selectCheckbox.length}
                delFuncSingle={delFuncSingle}
            />
            <Container maxWidth="xl" className="mt-20 mb-5 pt-5">
                <div>
                    <div className="mb-7 flex justify-between items-center">
                        <Typography variant="textheader2" component={'div'}>Unlinked CVs</Typography>
                        <ButtonImgMain 
                            variant='primary' 
                            type='button' 
                            disabled={false} 
                            name='Job Board'
                            class='capitalize'
                            img={ClipboardIcon}
                            posision={'right'}
                            onClick={()=>navigate(`/job-board`)}
                        />
                    </div>
                    <div className="flex justify-end">
                        <Tabs onChange={handleChange} value={value}>
                            <Tab label="Pending" value={0} />
                            <Tab label="Discarded" value={1} />
                        </Tabs>
                    </div>
                    
                    <div className='rounded-xl rounded-tr-none mb-5 bg-white p-5 pt-1 border border-solid border-cultured'>
                        <SimpleBar 
                            className={`${selectCheckbox.length > 0 ? 'review-selected':'review-unselected'} rounded-xl p-0 m-0`}
                            onScrollCapture={handleScroll}
                        >
                            {cvList?.pages?.[0]?.content?.length > 0 ? (
                                <div className='table-review'>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell className="max-w-[3rem]">
                                                    <Checkbox 
                                                        id="selectAll"
                                                        checkedIcon={<img src={Check} alt="View icon" className="w-[1.5rem]" />}
                                                        icon={<img src={Uncheck} alt="View icon" className="w-[1.5rem]" />}
                                                        onChange={(e)=>isCheckedAll(e.target.checked)}
                                                        checked={selectAll}
                                                        disabled={cvProcess}
                                                        className={`${cvProcess ? 'opacity-20':''} py-2`}

                                                    />
                                                </TableCell>
                                                <TableCell>File</TableCell>
                                                <TableCell>Applicant</TableCell>
                                                <TableCell>Upload Date</TableCell>
                                                <TableCell>Suggested Jobs</TableCell>
                                                <TableCell>Actions</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {cvList.pages.map((page, pageIndex) => ( 
                                                page.content.map((cv, index) => (
                                                    <TableRow
                                                        key={pageIndex+index}
                                                    >
                                                        <TableCell className="max-w-[3rem]">
                                                            <Checkbox 
                                                                checkedIcon={<img src={Check} alt="View icon" className="w-[1.5rem]" />}
                                                                icon={<img src={Uncheck} alt="View icon" className="w-[1.5rem]" />}
                                                                onChange={(e)=>{isChecked(e.target.checked, cv.id, cv.status)}}
                                                                id={`checkbox-${cv.id}`}
                                                                checked={selectCheckbox.includes(cv.id)}
                                                                disabled={cv.status === 'Processing' ? true : false}
                                                                className={cv.status === 'Processing' ? 'opacity-20':''}
                                                            />
                                                        </TableCell>
                                                        <TableCell className="max-w-[10vw] truncate">
                                                            {cv.attachmentName}
                                                        </TableCell>
                                                        <TableCell className="max-w-[15vw] truncate capitalize">
                                                            {cv.candidateName ? cv.candidateName : 'N/A'}
                                                        </TableCell>
                                                        <TableCell >{cv.processedDate? covertTimestamp(cv.processedDate) : 'N/A'}</TableCell>
                                                        <TableCell >{cv.suggestedJobName ? cv.suggestedJobName : 'N/A'}</TableCell>
                                                        <TableCell className={`${value !== 0 ? 'w-[16rem]':'w-[22rem]'}`}>
                                                            <Tooltip title="Summary">
                                                                <IconButton 
                                                                    aria-label="summary" 
                                                                    disabled={cv.status === 'Processing' || cv.status === 'Failed'? true : false}
                                                                    className={cv.status === 'Processing' || cv.status === 'Failed'? 'opacity-20 mr-2':'mr-2'}
                                                                    onClick={()=>summary(cv.summary, cv.candidateName, cv.rating, cv.ratingBreakdown)}
                                                                >
                                                                    <img src={Description} alt="message icon" className="w-[1.5rem]" />
                                                                </IconButton>
                                                            </Tooltip> 
                                                            <Tooltip title="View file">
                                                                <IconButton aria-label="View file" className="mr-2" onClick={()=>viewResume(cv.url)}>
                                                                    <img src={View} alt="View icon" className="w-[1.5rem]" />
                                                                </IconButton>
                                                            </Tooltip> 
                                                            {value === 0 ? (
                                                            <>
                                                                <Tooltip title="Link to job">
                                                                    <IconButton 
                                                                        aria-label="Link to job" 
                                                                        aria-controls={`menu-table-${index}`}
                                                                        aria-haspopup="true"
                                                                        onClick={(e) => handleMenu(e, index)}
                                                                        //onClick={() => shortlistSingle(cv.id)}
                                                                        disabled={false}
                                                                        className={'mr-2'}
                                                                    >
                                                                        <img src={linkedTo} alt="Link to job icon" className="w-[1.5rem]" />
                                                                    </IconButton>
                                                                </Tooltip> 
                                                                <Menu
                                                                    id={`menu-table-${index}`}
                                                                    anchorEl={activeMenuIndex === index ? anchorEl : null}
                                                                    anchorOrigin={{
                                                                        vertical: 'bottom',
                                                                        horizontal: 'left',
                                                                    }}
                                                                    keepMounted
                                                                    transformOrigin={{
                                                                        vertical: 'top',
                                                                        horizontal: 'left',
                                                                    }}
                                                                    open={activeMenuIndex === index}
                                                                    onClose={handleClose}
                                                                    className="assign-job-menu"
                                                                >
                                                                    {jobOpenings?.pages?.[0]?.length > 0 && jobOpenings.pages.map((page, pageIndex) => ( 
                                                                        page.map((job, index) => (
                                                                                <MenuItem  key={job.id} onClick={() => {handleClose(); assignToJob(job.id, cv.id)}}>
                                                                                    <div className="menuItem-wrapper">
                                                                                        {console.log('jobxx',JSON.stringify( job))}
                                                                                        <Typography textAlign="center" component={'div'} className={'menuItem-subText'} >{job.refId}</Typography>
                                                                                        <Typography textAlign="center" component={'div'} className={'menuItem'} >{job.title}</Typography>
                                                                                    </div>
                                                                                </MenuItem>
                                                                        ))
                                                                    ))}
                                                                </Menu>
                                                                <Tooltip title="Discard">
                                                                    <IconButton 
                                                                        aria-label="Discard"
                                                                        onClick={() => rejectSingle(cv.id)}
                                                                        disabled={cv.status === 'Processing' || cv.status === 'Failed' ? true : false}
                                                                        className={cv.status === 'Processing' || cv.status === 'Failed' ? 'opacity-20 mr-2':'mr-2'}
                                                                    >
                                                                        <img src={CloseCircle} alt="Discard icon" className="w-[1.5rem]" />
                                                                    </IconButton>
                                                                </Tooltip> 
                                                            </>
                                                            ):''}
                                                            <Tooltip title="Download">
                                                                <IconButton aria-label="Download" className="mr-2" onClick={()=>downloadSingle(cv.id, cv.attachmentName)}>
                                                                    <img src={Import} alt="Download icon" className="w-[1.5rem]" />
                                                                </IconButton>
                                                            </Tooltip> 
                                                            <Tooltip title="Delete">
                                                                <IconButton aria-label="delete" className="mr-2" onClick={()=>{setOpenDelete(true); setDelType(1); setDeleteId(cv.id)}}>
                                                                    <img src={TrashDark} alt="delete icon" className="w-[1.5rem]" />
                                                                </IconButton>
                                                            </Tooltip> 
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                            ))}
                                        </TableBody>
                                    </Table>
                                </div>
                                
                            ):(
                                loader ? (
                                    <div className="w-full flex-col flex justify-center items-center review-unselected">
                                        <img src={LoaderIcon} alt="loading" className="w-[4rem] mb-5"/>
                                        <Typography variant="textheader3" component={'div'}>Loading...</Typography>
                                    </div>
                                ):(
                                <div className="w-full flex-col flex justify-center items-center review-unselected">
                                    <img src={NotFound} alt="not found" className="w-[25%] mb-5"/>
                                    <Typography variant="textheader3" component={'div'}>CVs Not Found!</Typography>
                                </div>
                                )
                            )}
                            {isFetchingCvListNextPage && (
                                <div className="w-full flex-col flex justify-center items-center mt-4">
                                    <img src={LoaderIcon} alt="loading" className="w-[2rem]" />
                                </div>
                            )}
                        </SimpleBar>
                    </div>
                    {selectCheckbox.length > 0 ?( 
                        <FooterBarReveiw
                            shortlist={''}
                            reject={reject}
                            btnFill={'Upload'}
                            buttonRightDel={files.length < 1 ? 'Delete All':''}
                            delAll={delAll}
                            download={download}
                            selectedCount={selectCheckbox.length}
                            tab={value}
                        /> 
                    ):''}
                </div>
            </Container>
        </ThemeProvider>
        
    )
}

export default UnAssignedCv;